export * from './input-cpf.component';
